export const DEMO_MACHINE = {
  _id: "demo",
  name: "Demo Asset",
  image: "/images/twin-engine.png",
};

export const MACHINE_BROADCAST_TOPICS = {
  DOCUMENTATION_DETACHED: "DOCUMENTATION_DETACHED",
  WORK_ORDER_CREATED: "WORK_ORDER_CREATED",
};
